
import React from "react";
import { AIStaffMember } from "@/lib/types";
import { aiCandidates, roleCapabilities } from "./data";

// Import stage components
import AvailableAssistantsStage from "./AvailableAssistantsStage";
import InterviewStage from "./InterviewStage";
import OnboardingStage from "./OnboardingStage";

interface StageRendererProps {
  currentStage: number;
  selectedCandidate: number | null;
  isSubmitting: boolean;
  aiStaff: AIStaffMember | null;
  onSelectCandidate: (id: number) => void;
  onComplete: () => void;
}

const StageRenderer: React.FC<StageRendererProps> = ({
  currentStage,
  selectedCandidate,
  isSubmitting,
  aiStaff,
  onSelectCandidate,
  onComplete
}) => {
  switch (currentStage) {
    case 0: // Available Assistants (merged stage)
      return (
        <AvailableAssistantsStage 
          aiCandidates={aiCandidates}
          selectedCandidate={selectedCandidate}
          onSelectCandidate={onSelectCandidate}
        />
      );
      
    case 1: // Interview/Capabilities
      const candidate = aiCandidates.find(c => c.id === selectedCandidate);
      return (
        <InterviewStage 
          candidate={candidate}
          roleCapabilities={roleCapabilities}
        />
      );
      
    case 2: // Onboarding (previously case 3)
      return (
        <OnboardingStage 
          aiStaff={aiStaff}
          onComplete={onComplete}
        />
      );
      
    default:
      return null;
  }
};

export default StageRenderer;
